import { render } from "./TicketsClaimWaiting.vue?vue&type=template&id=01a12392&scoped=true&ts=true"
import script from "./TicketsClaimWaiting.vue?vue&type=script&lang=ts"
export * from "./TicketsClaimWaiting.vue?vue&type=script&lang=ts"

import "./TicketsClaimWaiting.vue?vue&type=style&index=0&id=01a12392&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a12392"]])

export default __exports__